module.exports = __webpack_public_path__ + "img/golf-bag.b8dd295d.svg";